<template>
	<MStateBox :loading="quarterlyPerformance.loading" :empty="isEmpty">
		<div v-if="column === 50" class="wrapper-box">
            <div
                class="report-wrapper"
                v-for="(report, index) in performanceData.slice(0, 3)"
                :key="index"
                @click="gotoPerformanceEntry(report.announcementLink, report.id)"
            >
                <img class="report-cover" v-loadPDF :data-src="report.announcementLink" alt="" />
                <div class="report-info">
                    <div class="report-title text-overflow">{{ report.performanceName }}</div>
                    <div class="report-date">{{ report.announcementDate }}</div>
                </div>
                <div class="download-btn" @click.stop="downloadFile(report.announcementLink)">
                    <SvgIcons name="icon_download" class="icon-download" /> {{ $t('enterprise.download') }}
                </div>
            </div>
        </div>
        <div v-else class="wrapper-full-box">
            <div
                class="full-report-wrapper"
                v-for="(report, index) in performanceData.slice(0, 4)"
                :key="index"
                @click="gotoPerformanceEntry(report.announcementLink, report.id)"
            >
				<ReportImage :item="report" class="full-report-cover"></ReportImage>
                <div class="full-report-name text-overflow">{{ report.performanceName }}</div>
            </div>
        </div>
	</MStateBox>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import MStateBox from '@rebuild/components/MStateBox.vue';
import SvgIcons from '@/components/SvgIcons.vue';
import { download } from '@/utils/download';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import ReportImage from '@rebuild/materials/shared/performance_report/ReportImage.vue'

defineProps({
	column: {
		type: Number,
		default: 100
	}
});

const { quarterlyPerformance } = useModuleData();

// 保持与历史组件相同的数据访问路径
const performanceData = computed(() => {
	const dataObj = quarterlyPerformance.data?.data || {};
	const dataList = Object.values(dataObj)
		.flat()
		.filter(ele => ele.announcementLink)
		.sort((a, b) => {
			if (a.performanceYear !== b.performanceYear) return b.performanceYear - a.performanceYear;
			else return b.quarter - a.quarter;
		});
	return dataList;
});

const isEmpty = computed(() => {
	return quarterlyPerformance.empty || !performanceData.value.length;
});

const { viewModule } = useModuleNavigation();
const gotoPerformanceEntry = (comeinLink, id) => {
	viewModule('performance_report', { comeinLink, id });
};

const downloadFile = (url) => {
	download(url);
};


const fetchData = async () => {
	await quarterlyPerformance.refresh({isAll: true});
};

onMounted(() => {
	fetchData();
});
</script>

<style lang="less" scoped>
.wrapper-box {
	padding: 32px 24px;
	background: linear-gradient(323deg, rgba(133, 57, 229, 0.03) 0%, rgba(133, 57, 229, 0.01) 100%);

	.report-wrapper {
		display: flex;
		align-items: center;
		cursor: pointer;

		.report-cover {
			width: 38px;
			height: 54px;
			border: 1px solid var(--border-lighter-color);
		}
		.report-info {
			margin-left: 12px;
			flex: 1;
			min-width: 0;
			height: 54px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}
		.report-title {
			color: var(--emphasis-color);
			 
			font-size: 16px;
			 
			font-weight: 500;
		}
		.report-date {
			color: var(--secondary-color);
			 
			font-size: 14px;
			 
			font-weight: 400;
			line-height: 16px; /* 114.286% */
		}
		.download-btn {
			color: var(--secondary-color);
			text-align: right;
			 
			font-size: 14px;
			 
			font-weight: 400;

			.icon-download {
				width: 20px;
				height: 20px;
				color: var(--secondary-color) !important;
			}
		}
	}
	.report-wrapper + .report-wrapper {
		margin-top: 44px;
	}
}

.wrapper-full-box {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;

	.full-report-wrapper {
		width: calc((100% - (calc(24px * 3))) / 4);
		margin-right: 24px;
		cursor: pointer;

		&:nth-child(4n) {
			margin-right: 0;
		}
		.full-report-cover {
			width: 100%;
			height: 396px;
			border: 1px solid var(--border-lighter-color, #f2f3f5);
		}
		.full-report-name {
			margin-top: 10px;
			text-align: center;
			color: #1d2129;
			 
			font-size: 16px;
			 
			font-weight: 500;
			line-height: 24px; /* 150% */
		}
	}
}
</style>
